import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  INCOMES_EDIT,
  INCOMES_UPDATE,
  INCOME_CATEGORY_LIST_DROPDOWN,
  USER_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { INCOME_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";

const parseFormDate = (value) => {
  if (!value) return "";
  const m = moment(
    value,
    [
      "DD/MM/YYYY",
      "YYYY-MM-DD",
      "DD/MM/YYYY hh:mm A",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss",
    ],
    true,
  );
  return (m.isValid() ? m : moment(value)).format("YYYY-MM-DD");
};

const IncomeEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userOptions, setUserOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    const formData = new FormData();
    formData.append("income_category_id", form.income_category_id);
    formData.append(
      "date",
      moment(form.date, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD"),
    );
    formData.append("notes", form.notes || "");
    formData.append("member_ids", JSON.stringify(form.member_ids || []));
    if (form.attachments?.length) {
      Array.from(form.attachments).forEach((file) => {
        formData.append("attachments", file);
      });
    }
    axios
      .put(INCOMES_UPDATE + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(INCOME_UPDATED);
          navigate("/incomes");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(INCOMES_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          const member_selected = (d.members || []).map((m) => ({
            value: Number(m.id),
            label: `${m.member_id} - ${m.name}`,
          }));
          setForm({
            member_ids: d.member_ids || member_selected.map((m) => m.value),
            member_selected,
            income_category_id: d.income_category_id,
            category_selected: d.income_category_id
              ? {
                  value: Number(d.income_category_id),
                  label: d.income_category_name,
                }
              : null,
            date: parseFormDate(d.date),
            notes: d.notes || "",
            attachments_existing: d.attachments || [],
            chapter_id: d.chapter_id,
          });
        }
      })
      .finally(() => setLoading(false));

    axios.get(INCOME_CATEGORY_LIST_DROPDOWN).then((res) => {
      if (res.status === 200 && res.data.success) {
        setCategoryOptions(res.data.data || []);
      }
    });
  }, [id]);

  useEffect(() => {
    if (form.chapter_id == null) return;
    axios
      .get(USER_LIST_DROPDOWN, {
        params: {
          chapter_id: form.chapter_id,
          exclude_other_region_chapter_users: 1,
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setUserOptions(res.data.data || []);
        }
      });
  }, [form.chapter_id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">Incomes</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/incomes"}>
                    <span>Incomes List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Income</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/incomes"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="member_ids">
                          Members<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="member_ids"
                          isMulti
                          options={userOptions}
                          placeholder="Select Members"
                          value={form.member_selected || []}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              member_ids: (selected || []).map((s) => s.value),
                              member_selected: selected || [],
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="member_ids" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="income_category_id"
                        >
                          Category<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="income_category_id"
                          options={categoryOptions}
                          placeholder="Select Category"
                          value={form.category_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              income_category_id: selected?.value,
                              category_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="income_category_id"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="date">
                          Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          id="date"
                          className="form-control"
                          placeholder="Select Date"
                          value={form.date || ""}
                          options={{ dateFormat: "Y-m-d" }}
                          onChange={(dates) =>
                            setForm({
                              ...form,
                              date: dates[0]
                                ? moment(dates[0]).format("YYYY-MM-DD")
                                : "",
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="date" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="notes">
                          Notes
                        </label>
                        <textarea
                          className="form-control"
                          id="notes"
                          placeholder="Notes"
                          rows={3}
                          value={form.notes || ""}
                          onChange={(e) =>
                            setForm({ ...form, notes: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="notes" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="attachments">
                          Attachments
                        </label>
                        {form.attachments_existing?.length > 0 && (
                          <div className="d-flex flex-wrap mb-2 gap-2">
                            {form.attachments_existing.map((file, idx) => (
                              <a
                                key={idx}
                                href={file}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-sm btn-outline-primary d-flex align-items-center"
                              >
                                <i className="bx bx-paperclip me-1"></i>
                                Attachment {idx + 1}
                              </a>
                            ))}
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          id="attachments"
                          name="attachments"
                          multiple
                          onChange={(e) =>
                            setForm({
                              ...form,
                              attachments: e.target.files,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="attachments" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/incomes"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomeEdit;
